import React, {PropTypes} from 'react';
import List, {defaultFilters} from '../cruds/List';
import View from '../cruds/View';
import Edit from '../cruds/Edit';
import {notEmpty, notEmptyForRoleG, stringNotBlank, stringValidEmail} from '../cruds/validators';
import {EditButton} from '../components/output/CrudButton';
import Table, {Column} from '../components/container/Table';
import OutputText, {SimpleOutputText} from '../components/output/OutputText';
import OutputValue from '../components/output/OutputValue';
import {SimpleOutputList} from '../components/output/OutputList';
import InputText from '../components/input/InputText';
import RemoteInputSelect from '../components/input/RemoteInputSelect';
import MainContainer from '../components/MainContainer';
import {Route, Switch} from 'react-router-dom';
import {ResetPasswordButton, ToggleEnableButton} from './UserButtons';
import WithRole, {withRoles} from '../components/container/WithRole';
import {
    MACHINERY_CRUD_ENABLED,
    MULTIPLE_DEPARTMENT_PER_USER,
    ShowBasedOnConfig
} from "../components/container/ShowBasedOnConfig";
import RemoteInputDualList from "../components/input/RemoteInputDualList";
import {ShowBasedOnCondition} from "../components/container/ShowBasedOnCondition";

const ENTITY_NAME = 'users';
const TITLE = 'users.title';

const CrudNew = (props, context) => {
    const validators = [
        stringNotBlank('firstName', 'users.err.firstName'),
        stringNotBlank('lastName', 'users.err.lastName'),
        stringNotBlank('username', 'users.err.username'),
        stringValidEmail('email', 'users.err.email'),
        notEmpty('roles', 'users.err.roles'),
        notEmptyForRoleG(context.config[MULTIPLE_DEPARTMENT_PER_USER] === true ? 'departmentIds ' : 'departmentId', 'users.err.department')
    ];
    return (
        <Edit {...props}
              title={TITLE}
              entityName={ENTITY_NAME}
              entityRoute={ENTITY_NAME}
              entityId={props.match.params.number}
              validators={validators}
        >
            <InputText name="firstName" label="users.firstName"/>
            <InputText name="lastName" label="users.lastName"/>
            <InputText name="email" label="users.email"/>
            <InputText name="username" label="users.username"/>
            <RemoteInputSelect
                from={ENTITY_NAME + '/roles'}
                optionValueName="value"
                optionLabelName="value"
                name="roles"
                label="users.role"
                localize="users.roleNames"
                multi={true}
            />
            <ShowBasedOnConfig configKey={MULTIPLE_DEPARTMENT_PER_USER} name="departmentId" enabledOn={false}>
                <RemoteInputSelect
                    from="departments"
                    order="NAME"
                    optionValueName="id"
                    optionLabelName="name"
                    name="departmentId"
                    label="users.department"/>
            </ShowBasedOnConfig>
            <ShowBasedOnConfig configKey={MULTIPLE_DEPARTMENT_PER_USER} name="departmentIds">
                <RemoteInputDualList
                    from="departments?order=NAME"
                    optionLabelName="name"
                    name="departmentIds"
                    label="users.department"
                    canFilter
                />
            </ShowBasedOnConfig>
            <ShowBasedOnCondition evaluateOnField="roles" condition={v => v.includes("F")} name="machineryIds">
                <ShowBasedOnConfig configKey={MACHINERY_CRUD_ENABLED} name="machineryIds">
                    <RemoteInputDualList
                        from="machineries?order=NAME"
                        optionLabelName="name"
                        name="machineryIds"
                        label="users.machineries"
                        canFilter
                    />
                </ShowBasedOnConfig>
            </ShowBasedOnCondition>
        </Edit>
    );
};

CrudNew.contextTypes = {
    config: PropTypes.object,
};


const CrudEdit = (props, context) => {
    const validators = [
        stringNotBlank('firstName', 'users.err.firstName'),
        stringNotBlank('lastName', 'users.err.lastName'),
        stringNotBlank('username', 'users.err.username'),
        stringValidEmail('email', 'users.err.email'),
        notEmpty('roles', 'users.err.roles'),
        notEmptyForRoleG(context.config[MULTIPLE_DEPARTMENT_PER_USER] === true ? 'departmentIds ' : 'departmentId', 'users.err.department')
    ];
    return (
        <Edit {...props}
              title={TITLE}
              entityName={ENTITY_NAME}
              entityRoute={ENTITY_NAME}
              entityId={props.match.params.number}
              validators={validators}
        >
            <InputText name="firstName" label="users.firstName"/>
            <InputText name="lastName" label="users.lastName"/>
            <InputText name="email" label="users.email"/>
            <SimpleOutputText name="username" label="users.username"/>
            <RemoteInputSelect
                from={ENTITY_NAME + '/roles'}
                optionValueName="value"
                optionLabelName="value"
                name="roles"
                label="users.role"
                localize="users.roleNames"
                multi={true}
            />
            <ShowBasedOnConfig configKey={MULTIPLE_DEPARTMENT_PER_USER} name="departmentId" enabledOn={false}>
                <RemoteInputSelect
                    from="departments"
                    order="NAME"
                    optionValueName="id"
                    optionLabelName="name"
                    name="departmentId"
                    label="users.department"/>
            </ShowBasedOnConfig>
            <ShowBasedOnConfig configKey={MULTIPLE_DEPARTMENT_PER_USER} name="departmentIds">
                <RemoteInputDualList
                    from="departments?order=NAME"
                    optionLabelName="name"
                    name="departmentIds"
                    label="users.department"
                    canFilter
                />
            </ShowBasedOnConfig>
            <ShowBasedOnCondition evaluateOnField="roles" condition={v => v.includes("F")} name="machineryIds">
                <ShowBasedOnConfig configKey={MACHINERY_CRUD_ENABLED} name="machineryIds">
                    <RemoteInputDualList
                        from="machineries?order=NAME"
                        optionLabelName="name"
                        name="machineryIds"
                        label="users.machineries"
                        canFilter
                    />
                </ShowBasedOnConfig>
            </ShowBasedOnCondition>
        </Edit>
    );
};

CrudEdit.contextTypes = {
    config: PropTypes.object,
};

const CrudView = props => (
    <View title={TITLE} entityName={ENTITY_NAME} entityRoute={ENTITY_NAME} entityId={props.match.params.number}>
        <OutputText name="name" label="users.fullName"/>
        <OutputText name="username" label="users.username"/>
        <OutputText name="email" label="users.email"/>
        <OutputText name="role" label="users.role"/>
    </View>
);

const CrudList = props => {
    const table = <Table>
        <Column label="users.firstName" orderingName="FIRST_NAME">
            <OutputValue name="firstName" style={{marginRight: 5}}/>
        </Column>
        <Column label="users.lastName" orderingName="LAST_NAME">
            <OutputValue name="lastName" style={{marginRight: 5}}/>
        </Column>
        <Column label="users.username" orderingName="USERNAME">
            <OutputValue name="username"/>
        </Column>
        <Column label="users.email" orderingName="EMAIL">
            <OutputValue name="email"/>
        </Column>
        <Column label="users.roles">
            <SimpleOutputList name="roles" localize="users.roleNames"/>
        </Column>
        <Column label="users.department">
            <OutputValue name="departments"/>
        </Column>
        <ShowBasedOnConfig configKey={MACHINERY_CRUD_ENABLED} label="users.machineries">
            <Column label="users.machineries">
                <OutputValue name="machineries"/>
            </Column>
        </ShowBasedOnConfig>
        <Column>
            <WithRole roles={'A'}>
                <EditButton entityRoute={props.match.url}/>
            </WithRole>
            <WithRole roles={'A'}>
                <ToggleEnableButton/>
            </WithRole>
            <WithRole roles={'A'}>
                <ResetPasswordButton/>
            </WithRole>
        </Column>
    </Table>;

    return <List title={TITLE}
                 entityName={ENTITY_NAME}
                 entityRoute={ENTITY_NAME}
                 component={table}
                 defaultOrdering="USERNAME"
                 filters={defaultFilters()}
                 hideAddButton={!withRoles(['A'])}
    />;
};

const Users = props => {
    const basePath = props.match.url;
    return (
        <MainContainer>
            <Switch>
                <Route exact path={basePath} component={CrudList}/>
                <Route exact path={basePath + '/view/:number'} component={CrudView}/>
                <Route exact path={basePath + '/edit/:number'} render={props => <CrudEdit {...props} />}/>
                <Route exact path={basePath + '/add'} render={(props, context) => <CrudNew {...props} />}/>
            </Switch>
        </MainContainer>
    );
};


export default Users;



// WEBPACK FOOTER //
// ./src/main/pages/Users.js